import React, { useEffect, useRef, useState } from "react";
import crmservices from '../../wsclient';
import { useTranslation } from "react-i18next";
import RemoveDeviceDetailView from "./RemoveDeviceDetailView";
import { createCustomFieldObj, getCustomFieldByKey, sleep } from "../../utils/util";
import { httpBackOfficeUtil } from "../../wsclient/crmservices/httpBackOfficeUtil";
import ConfirmComponent from "../../components/Confirm";
import UploadFile from "../../components/UploadFile";
import TotalActivitiesView from "./TotalActivitiesView";
import InstallationDetailView from "./InstallationDetailView";
import SwapDeviceDetailView from "./SwapDeviceDetailView";
import ServiceVisitDetailView from "./ServiceVisitDetailView";
import ReinstallationDetailView from "./ReinstallationDetailView";
import InstallationController from "./InstallationController";
import GeneralActivityDetailView from "./GeneralActivityDetailView";
import { connection } from "../../portal.config";
import { getData } from "../../utils/common";
import AdditionalBoxController from "./AdditionalBoxController";
import AdditionalBoxDetailView from "./AdditionalBoxDetailView";
import { getListItemAvatarUtilityClass } from "@mui/material";

const MAXIUM_FILE = 3;
export default function TotalActivitiesController(props) {
    console.log('TotalActivitiesController props:', props);
    const organisation_id = document._portalConfig.organisation_id;
    const { t } = useTranslation();
    const [activities, setActivities] = useState([]); //list of  total activities
    const [removedDevice, setChangeRemoveDevice] = useState("");//list of  total activities
    const [addedDevice, setChangeAddDevice] = useState("");
    const [orderDetail, setOrderDetail] = useState(null);
    const [showLoading, setShowLoading] = useState(true);
    const [showExecutionProcess, setShowExecutionProcess] = useState(false);
    //detail
    // const [showDetail, setShowDetail] = useState(false);
    const [showUploadFile, setShowUploadFile] = useState(false);
    const [filesUpload, setFilesUpload] = useState([]);
    const [files, setFiles] = useState([]);
    const [contactAttachments, setContactAttachments] = useState([]);
    const [isLoadedAttachments, setIsLoadedAttachments] = useState(false);
    const [isReloadAttachment, setIsReloadAttachment] = useState(false);
    const [pageTotal, setPageTotal] = useState(0);
    // parse to modal detail
    const [activity, setActivity] = useState(null);
    // update LinearBuffer
    const [actionState, setActionState] = useState(null);
    const [isSelfScheduleingUser, setSelfScheduleingUser] = useState(null);
    // note
    const [allNote, setAllNote] = useState([]);
    const [dataNoteActivity, setDataNoteActivity] = useState([]);
    const [loadMoreNote, setLoadMoreNote] = useState(false);
    const [pagingNote, setPagingNote] = useState({
        page: 1,
        size: 10,
        total: 0,
        has_more: false,
    })
    const [paging, setPaging] = useState({
        page: 1,
        size: 10,
        total: 0,
        has_more: false
    });

    const [showDetail, setShowDetail] = useState({
        installation: false,
        uninstallation: false,
        swapping: false,
        reinstallation: false,
        serviceVisit: false,
        additionalBox: false,
        other: false
    });

    const [activeStepAddDevice, setActiveStepAddDevice] = useState(false);
    const [isClickAddDeviceBtn, setClickAddDeviceBtn] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const [dataSearch, setDataSearch] = useState([]);
    const [typesSelected, setTypesSelected] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [types, setTypes] = useState([]);
    const [validate, setValidate] = useState(false);
    const [citySelected, setCitySelected] = useState(null);
    const [cities, setCities] = useState([]);

    const setShowProcessing = props.setShowProcessing;
    const showMessage = props.showMessage;

    useEffect(() => {
        onLoadActivities();
        onLoadActivityTypes();
        onLoadActivityStatuses();
        onLoadCityCustomFields();
    }, []);

    // function to load list of activities remove device
    const onLoadActivities = async (page, size) => {
        setShowLoading(true);
        setActivity(null)

        try {
            let pg = 1;
            let totalLoad = 0;
        let data = [];
                    const result = await crmservices.activities.getActivities({
                page: pg,
                size: 100,
                state: "PENDING",
                include_total: true,
                sort: 'SCHEDULED_DATE',
                order: 'DESC'
            });
            if (result.code === 'OK') {
                console.log("onLoadActivities:", result);
                data = result.data.content ? result.data.content : [];
                totalLoad = data.length;

                while(totalLoad < result.data.paging.total){
                    pg++;
                    
                    const resultPg = await crmservices.activities.getActivities({
                        page: pg,
                        size: 100,
                        state: "PENDING", 
                        include_total: true,
                        sort: 'SCHEDULED_DATE',
                        order: 'DESC'
                    });

                    if (resultPg.code === 'OK') {
                        console.log("onLoadActivities page :", pg);
                        console.log("onLoadActivities:", resultPg);
                        let dataPg = resultPg.data.content ? resultPg.data.content : [];
                        totalLoad += dataPg.length;
                        
                        data = [...data, ...dataPg];
                    }
            }
}
            console.log("onLoadActivities all data:  ", data);
            // để bảng lấy key cho dễ
            let _data = data.map(activity => {
                let field1 = activity.custom_fields.find(field => field.key === 'activity_number');
                let field2 = activity.custom_fields.find(field => field.key === 'status');
                return { ...activity, activity_number: field1?.value, status: field2?.value };
            });

            setActivities(_data);
                    } catch (error) {
            console.log("load activity remove device error:", error);
        }
        setShowLoading(false);
    }

    const handleChangePage = async (page) => {
        console.log("AAA page:", page);
        await onLoadActivities(page);
    }

    const handleChangeRowsPerPage = async (size) => {
        console.log("AAA size:", size);
        await onLoadActivities(1, size);
    }

    //function to handle show detail
    const onShowDetail = async (activity) => {
       
        const _isSelfScheduleingUser = getData('isSelfScheduleingUser');
        // console.log("onShowDetail isSelfScheduleingUser:", _isSelfScheduleingUser); 
        setSelfScheduleingUser(_isSelfScheduleingUser);  
        
        const accessToken = getData('access_token')
        var url = connection.crmConfig.crmServer + '/backoffice/v2/contacts/'+ activity.contact.id +'/attachments';
        let attachments = await fetch(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                method: 'GET',
            }
        });

        let attachmentRsl = await attachments.json();
        let fileTobeShowns = [];
        if(attachmentRsl && attachmentRsl.content){
            let custom_fields = activity.custom_fields ? activity.custom_fields : [];
            let fileCustomField = getCustomFieldByKey(custom_fields, 'attachments_file_id');
            if(fileCustomField){
                let fileCustomFields = [];
                fileCustomFields = fileCustomField.split(',');
                if (fileCustomFields && fileCustomFields.length > 0) {
                    fileCustomFields.forEach(fl => {
                        for(let i = 0; i < attachmentRsl.content.length; i++){
                            let file = attachmentRsl.content[i];
                            if(file.file.id == fl)
                                fileTobeShowns.push(file);
                        }
                    });
                }
            }

            if(fileTobeShowns.length > 0){
                let _activity = { ...activity, files:fileTobeShowns };
                setActivity(_activity);
            }            
        }        
        
        setIsLoadedAttachments(false);
        let type = activity.type.name.trim();
        let actionToShow = 'other';
        let configTypes = document._portalConfig.activity_types;
        
        if(configTypes){
            for(let i=0; i < configTypes.length; i++){
                let cfType = configTypes[i];
                
                if(cfType.types.includes(type)){
                    actionToShow = cfType.action;
                    break;
                }
            }
        }
        console.log("type = " + type + ", action = " + actionToShow);
        
        if (actionToShow == 'installation') {
            await onShowDetailInstallation(activity)
        } 
        // else if (actionToShow == 'additionalBox'){
        //     if (activity && activity.contact) {
        //         setOrderDetail(activity.contact);
        //         setShowDetail((prevState) => ({
        //           ...prevState,
        //           [actionToShow]: true,
        //         }));
        //         checkActiveTab(activity);
        //         setShowProcessing(false);
        //       }
        // } 
        else {
            setFiles([]);
            setShowProcessing(true);
            try {
                const result = await crmservices.activities.getActivity(activity.id);
                if (result.code == 'OK') {
                    let activityData = result.data;
                    // get contact detail
                    if (activityData.contact) {
                        var result2 = await crmservices.contacts.getContact(activityData.contact.id);
                        if (result2.code == 'OK') {
                            activityData = { ...activityData, contact: { ...result2.data, id: activityData.contact.id } }
                        }
                    }
                    //
                    if(fileTobeShowns.length > 0){
                        let _activityData = { ...activityData, files:fileTobeShowns };
                        setActivity(_activityData);
                    } else
                        setActivity(activityData);
                    
                    setShowDetail(prevState => ({
                        ...prevState,
                        [actionToShow]: true
                    }));
                } else {
                    showMessage({
                        status: true,
                        message: t('NO_ACTIVITY_FOUND'), //TODO: correct message
                    });
                }
            } catch (ex) {
                console.log("onShowDetail ex:", ex);
                showMessage({
                    status: true,
                    message: t('EXCEPTION_PROCESS'),
                });
            }
            setShowProcessing(false);
        }
    }

    const checkActiveTab = (activity) => {
		let _active = 0;
		let addingDevice = getCustomFieldByKey(activity.custom_fields, "addingdevice");
		let enable_device = getCustomFieldByKey(activity.custom_fields, "enable_device");
		if(!addingDevice || addingDevice == "0"){
			_active = 0;
		}else{
			if(!enable_device || enable_device == "0"){
				_active = 1;
			}else{
				_active = 2;
			}
        }
        console.log('checkActiveTab = ', _active);
		setActiveStepAddDevice(_active)
	}

    const setAddress = async (installation) => {
        let contactId = installation.contact ? installation.contact.id : null;
        try {
            const result = await crmservices.contacts.getContact(contactId);
            if (result.code == 'OK') {
                let contactAddresses = result.data.addresses;
                let primaryAddress = contactAddresses.filter(address => address.is_primary === true)[0];
                return { ...installation, contact_address: primaryAddress };
            }
        } catch (ex) {

        }
    }

    const onShowDetailInstallation = async (installation) => {
        console.log('onShowDetailInstallation:', installation);
        
        setShowProcessing(true);
        if (activity && activity.id == installation.id) {
            setShowDetail(prevState => ({
                ...prevState,
                installation: true
            }));
            setShowProcessing(false);
            setFiles([]);
            setFilesUpload([]);            
        } else {
            setIsLoadedAttachments(false);
            try {
                if (installation.order && installation.order.id) {
                    const result = await crmservices.orders.getOrderDetail(installation.order.id);
                    console.log('getOrderDetail result:', result);
                    if (result.code == 'OK') {
                        let _orderDetail = result.data;
                        _orderDetail = await setAddress(_orderDetail);
                        const activityDetail = await crmservices.activities.getActivity(installation.id);
                        console.log('activityDetail result:', activityDetail);
                        if (activityDetail.code == 'OK') {
                            let activityData = activityDetail.data;
                            // get contact detail
                            if (activityData.contact) {
                                var result2 = await crmservices.contacts.getContact(activityData.contact.id);
                                if (result2.code == 'OK') {
                                    activityData = { ...activityData, contact: { ...result2.data, id: activityData.contact.id } }
                                }
                            }
                            setOrderDetail(_orderDetail);
                            setActivity(activityData)
                            setShowDetail(prevState => ({
                                ...prevState,
                                installation: true
                            }));
                        } else {
                            showMessage({
                                status: true,
                                message: t('NO_ACTIVITY_FOUND'), //TODO: correct message
                            });
                        }
                    } else {
                        showMessage({
                            status: true,
                            message: t('NO_ACTIVITY_FOR_ORDER'),
                            title: t('ERROR'),
                        });
                    }
                } else {
                    showMessage({
                        status: true,
                        message: t('EXCEPTION_PROCESS'),
                        title: t('ERROR'),
                    });
                }
            } catch (ex) {
                console.log("onShowDetail ex:", ex);
                showMessage({
                    status: true,
                    message: t('EXCEPTION_PROCESS'),
                    title: t('ERROR'),
                });
            }
            setShowProcessing(false);
        }
    }
    
    // call when subscription action state is executed
    const onUpdateActivity = async ({ 
        note, 
        removedSerial, 
        saveButtonPressed = false, 
        scheduledDate, 
        scheduledTime, 
        scheduledTimeFrom, 
        scheduledTimeTo,
		changeScheduleDate = false,
        submitForm = false,
    }) => {
        // console.log('onUpdateActivity scheduledDate = ', scheduledDate);
        // console.log('onUpdateActivity activity.custom_fields before update = ', activity.custom_fields);
        // console.log('onUpdateActivity scheduledTime = ', scheduledTime);
        // console.log('onUpdateActivity scheduledTimeFrom = ', scheduledTimeFrom);
        // console.log('onUpdateActivity scheduledTimeTo = ', scheduledTimeTo);

        if (saveButtonPressed || showDetail.reinstallation || showDetail.serviceVisit)
            setShowProcessing(true);

        if (scheduledTimeFrom && scheduledTimeTo && new Date(scheduledTimeFrom) >= new Date(scheduledTimeTo)) {
            showMessage({ status: true, message: t('UPDATE_ACTIVITY_FROMTIME_TOTIME_INVALID') });
            return;
        }

        let custom_fields = activity.custom_fields ? activity.custom_fields : [];

        if (removedSerial)
            custom_fields = createCustomFieldObj(custom_fields, "device_removed", removedSerial);

        if (note)
            custom_fields = createCustomFieldObj(custom_fields, "notes", note);

        const fileUploaded = await onUploadFile();
        let strFileUploaded = fileUploaded && fileUploaded.length > 0 ? fileUploaded.join(",") : null;
        if (strFileUploaded) {
            let fileCustomFields = getCustomFieldByKey(custom_fields, 'attachments_file_id');
            if (fileCustomFields) {
                fileCustomFields = fileCustomFields + "," + strFileUploaded
            } else {
                fileCustomFields = strFileUploaded;
            }
            custom_fields.push({
                key: 'attachments_file_id',
                value: fileCustomFields
            })
        }

        console.log('custom fields tobe updated= ', custom_fields);
        try {
            let _scheduledTimeFrom = null;
            if (scheduledTime && scheduledTime != 'ALL' && scheduledTimeFrom)
                _scheduledTimeFrom = (new Date(scheduledTimeFrom)).toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit' });

            let _scheduledTimeTo = null;
            if (scheduledTime && scheduledTime != 'ALL' && scheduledTimeTo)
                _scheduledTimeTo = (new Date(scheduledTimeTo)).toLocaleTimeString([], {
                    hour12: false, hour: '2-digit', minute: '2-digit'
                });
            const noteResult = await addNote();
            if (noteResult) {
                setAllNote([])
                onLoadNoteActivity()
            }
			let isUpdateActivity = false;
			if (changeScheduleDate || submitForm) isUpdateActivity = true;
			else isUpdateActivity = false;
            if (isUpdateActivity) {
                const result = await crmservices.activities.updateActivity({
                    activity_id: activity.id, 
                    state: saveButtonPressed ? undefined : "COMPLETED", 
                    custom_fields: custom_fields, 
                    date: scheduledDate, 
                    scheduledTimeFrom: _scheduledTimeFrom, 
                    scheduledTimeTo: _scheduledTimeTo,
                });
                if (result.code === 'OK') {
                    onLoadActivities(paging.page, paging.size);
                    if (saveButtonPressed || showDetail.reinstallation || showDetail.serviceVisit || showDetail.other
                        || showDetail.swapping) {
                        showMessage({ status: true, message: t('UPDATE_ACTIVITY_SUCCESS') })
                        setShowDetail(false)
                    }
                } else {
                    showMessage({ status: true, message: (result.data && result.data.message) ? result.data.message : t('UPDATE_ACTIVITY_FAIL') })
                }
            }
        } catch (ex) {
            console.log("onUpdateActivity ex:", ex);
            if (saveButtonPressed) showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
        }
        setShowProcessing(false);
    }

    const completeActivity = async () => {  
        setShowProcessing(true);           
        try {
            const result = await crmservices.activities.updateActivity({ activity_id: activity.id, state: "COMPLETED" });
            if (result.code === 'OK' ) {
                onLoadActivities(paging.page, paging.size);
                setAllNote([])
                showMessage({ status: true, message: t('UPDATE_ACTIVITY_SUCCESS') });
                setShowDetail(false);
            } else {
                showMessage({ status: true, message: (result.data && result.data.message) ? result.data.message : t('UPDATE_ACTIVITY_FAIL') });
            }                
        } catch (ex) {
            console.log("onUpdateActivity ex:", ex);
            showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
        }
        setShowProcessing(false);
    };
    
    const addNote = async () => {
        try {
            for (let i = 0; i < allNote.length; i++) {
                const result = await crmservices.activities.addNoteActivity({ activity_id: activity.id, note: allNote[i] });
                if (result.code !== "OK") {
                    showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
                    return false; 
                }
            }
            return true;
        } catch (ex) {
            console.log("addNote ex:", ex);
            showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
            return false;
        }
    };
    const onLoadNoteActivity = async()=>{
        try {
            const result = await crmservices.activities.getListNoteActivity({ activity_id: activity.id });
            if (result.code == 'OK') {
                setDataNoteActivity(result.data.content)
                setPagingNote(result.data.paging);
            }
        } catch (ex) {
            console.log("onUpdateActivity ex:", ex);
            showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
        }
    }
    const onLoadMoreNoteActivity = async() => {
        setLoadMoreNote(true);
        try {
            const result = await crmservices.activities.getListNoteActivity({ 
                activity_id: activity.id,
                page: pagingNote.page + 1,
            });
            if (result.code == 'OK') {
                let _content = dataNoteActivity.concat(result.data.content);
                setDataNoteActivity(_content)
                setPagingNote({
                    ...result.data.paging,
                    total: pagingNote.total,
                });
            }
        } catch (ex) {
            console.log("onUpdateActivity ex:", ex);
            showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
        }
        setLoadMoreNote(false);
    }
   
    // get state to use in updateActivityIfExecuted function
    // const getSubscriptionActionState = async (actionId) => {
    //     let state = null;
    //     try {
    //         const result = await crmservices.subscriptions.getSubscriptionAction({
    //             action_id: actionId
    //         });
    //         if (result.code === 'OK') {
    //             state = result.data.state;
    //             console.log("SubscriptionActionState: ", state);
    //         }
    //     } catch (error) {
    //         state = 'EXCEPTION'
    //         console.log("get updatingState error:", error);
    //     }
    //     return state;
    // }

    // const updateActivityIfExecuted = async (actionId, note, removedSerial, device) => {
    //     // setShowProcessing Subscriptions action is being executed
    //     setShowExecutionProcess(true);
    //     let attempts = 3;
    //     let currentState;
    //     while (currentState !== "EXECUTED" && attempts > 0) { //
    //         currentState = await getSubscriptionActionState(actionId)
    //         if (currentState !== "PENDING_VERIFICATION") break;
    //         if (attempts != 3) await sleep(3000); //delay 3s after first attempt
    //         attempts--;
    //     }
    //     if (currentState === "EXECUTED") {
    //         await onUpdateActivity(note, removedSerial);
    //         props.onReloadRemoveList();
            
    //         let myUserId = httpBackOfficeUtil.getSession().sub;
    //         let custom_fields = device.custom_fields ? device.custom_fields : [];
    //         custom_fields = createCustomFieldObj(custom_fields, "contractor", myUserId);
    //         if (device.id)
    //             crmservices.subscriptions.updateDevice({ custom_fields: custom_fields }, device.id);
    //     }
    //     setActionState(currentState);
    //     await sleep(500);
    //     setShowExecutionProcess(false);
    // }

    // const onSubmitRemoveDevice = (note) => async (formData) => {
    //     console.log("onSubmitRemoveDevice:", formData)
    //     console.log('onSubmitRemoveDevice note: ', note);
    //     let contactId = activity.contact ? activity.contact.id : null;
    //     if (formData.removedSerial) {
    //         setShowProcessing(true);
    //         try {
    //             const result = await crmservices.subscriptions.getDevice({
    //                 contact_id: contactId,
    //                 serial_number: formData.removedSerial,
    //                 in_warehouse: false,
    //             })
    //             if (result.code == 'OK' && result.data.content && result.data.content.length > 0) {
    //                 let device = result.data.content[0];
    //                 if (device.subscriptions && device.subscriptions.length > 0) {
    //                     if (device.enabled_services) {
    //                         let check = device.enabled_services.find((service) => (service.life_cycle_state === "DRAFT" || service.life_cycle_state === "EFFECTIVE"));
    //                         if (check) {
    //                             showMessage({ status: true, message: t('REMOVE_DEVICE_EXCEPTION') });
    //                             return;
    //                         }
    //                     }
    //                     let subscriptionId = device.subscriptions[0].id;
    //                     const result2 = await crmservices.subscriptions.updateSubscriptionDevice({ action: "REMOVE" }, subscriptionId, device.id);
    //                     props.setShowProcessing(false);
    //                     if (result2.code == 'OK') {
    //                         setShowDetail(false);
    //                         showMessage({ status: true, message: t('REMOVE_SUCCESS') });
    //                         let actionId = result2.data.id;
    //                         await updateActivityIfExecuted(actionId, note, formData.removedSerial, device);
    //                     }
    //                     else if (result2.code == 'CANNOTEXECUTESUBSCRIPTIONACTIONEXCEPTION') {
    //                         showMessage({ status: true, message: t('REMOVE_DEVICE_EXCEPTION') });
    //                     }
    //                     else {
    //                         showMessage({
    //                             status: true,
    //                             message: t('UNKNOWN'), //TODO: correct message
    //                         });
    //                     }
    //                 }
    //             } else {
    //                 showMessage({
    //                     status: true,
    //                     message: t('NO_DEVICE_FOUND'), //TODO: correct message
    //                 });
    //             }
    //         } catch (ex) {
    //             console.log("onSubmitRemoveDevice ex:", ex);
    //             showMessage({
    //                 status: true,
    //                 message: t('EXCEPTION_PROCESS') + ' hehehe',
    //             });
    //         }
    //         setShowProcessing(false);
    //     }
    // }

    const onUploadFile = async () => {
        console.log("AAAA onUploadFile files: ", files)
        let _filesUploaded = [];
        try {
            console.log("files:", files)
            if (files.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    console.log("files[i]:", files[i])
                    const result = await crmservices.attachments.uploadFiles({ file: files[i], disalbedContentType: true });
                    console.log("AAAA onUploadFile result: ", result)
                    if (result.code == 'OK' && result.data.id) {
                        const addContactResult = await onAddContactAttachment(result.data.id);
                        if (addContactResult) {
                            _filesUploaded.push(result.data.id)
                        }
                    }
                }
            }
        } catch (error) {
            console.log("onUploadFile exception:", error);
        }
        return _filesUploaded
    }

    const onAddContactAttachment = async (file_id) => {
        let successfull = false;
        try {
            const contactId = activity.contact.id;
            let result = await crmservices.attachments.addContactAttachment({
                file_id: file_id,
                contact_id: contactId
            });
            if (result.code == 'OK') {
                successfull = true;
            }
            console.log("AAAA onAddContactAttachment result: ", result)
        } catch (error) {
            console.log("onAddContactAttachment exception:", error);
        }
        return successfull;
    }

    const onDeleteFile = (file) => {
        console.log("file==", file);
        const filesExist = files.filter(f => f.id !== file.id);
        setFiles(filesExist);
    }

    const uploadFiles = (files) => {
        if (files.length > MAXIUM_FILE) {
            showMessage({ status: true, message: t('error_max_files') })
            return false;
        }
        setFilesUpload(files);
    }

    const onSaveFilesState = () => {
        if (filesUpload && filesUpload.length > 0) setFiles(filesUpload);
        setShowUploadFile(false);
    }

    const onCloseDetail = async(type) => {
        console.log('onCloseDetail type = ', type);
        setShowDetail(prevState => ({
            ...prevState,
            [type]: false
        }));
        
        await sleep(2000);
        onLoadActivities(paging.page, paging.size);
    }

    //check if added device is allowd by subscription
    const getSubscriptionDevice = async (addedSerial) => {
        try {
            let myUserId = httpBackOfficeUtil.getSession().sub;
            const result = await crmservices.subscriptions.getDevice({
                owner_id: organisation_id,
                serial_number: addedSerial,
                include_custom_fields: true,
                custom_fields: `contractor;${myUserId}`,
                include_subscription: false
            });
            if (result.code === 'OK' && result.data.content && result.data.content.length > 0) {
                return result.data.content[0];
            } else {
                showMessage({
                    status: true,
                    message: t('DEVICE_NOT_ALLOWED'),
                });
            }
        } catch (ex) {
            console.log("getSubscriptionDevice ex:", ex);
            showMessage({
                status: true,
                message: t('EXCEPTION_PROCESS') + 'hihiahi',
            });
        }
    }

    // const onSubmitSwapDevice = (note) => async (formData) => {
    //     console.log("onSubmitSwapDevice:", formData);
    //     console.log("onSubmitSwapDevice note:", note);
    //     let contactId = activity.contact ? activity.contact.id : null;
    //     if (formData && formData.removedSerial && formData.addedSerial) {
    //         setShowProcessing(true);
    //         try {
    //             const result = await crmservices.subscriptions.getDevice({
    //                 contact_id: contactId,
    //                 serial_number: formData.removedSerial,
    //                 in_warehouse: false,
    //             })
    //             if (result.code == 'OK' && result.data.content && result.data.content.length > 0) {
    //                 let deviceRemoved = result.data.content[0];
    //                 let deviceAdded = await getSubscriptionDevice(formData.addedSerial)
    //                 if (deviceRemoved.subscriptions && deviceRemoved.subscriptions.length > 0 && deviceAdded) {
    //                     let subscriptionId = deviceRemoved.subscriptions[0].id;
    //                     const result2 = await crmservices.subscriptions.updateSubscriptionDevice({ action: "REPLACE", replaced_by_device_id: deviceAdded.id }, subscriptionId, deviceRemoved.id);
    //                     setShowProcessing(false);
    //                     if (result2.code == 'OK') {
    //                         onCloseDetail('swapping')
    //                         showMessage({ status: true, message: t('SWAP_SUCCESS') });
    //                         let actionId = result2.data.id;
    //                         await updateActivityIfExecuted(actionId, note, formData.removedSerial, formData.addedSerial, deviceRemoved);
    //                     }
    //                     else if (result2.code == 'CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION') {
    //                         showMessage({
    //                             status: true,
    //                             message: t('SWAP_DEVICE_CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION'),
    //                         });
    //                     }
    //                     else {
    //                         showMessage({
    //                             status: true,
    //                             message: t('UNKNOWN'), //TODO: correct message
    //                         });
    //                     }
    //                 }
    //             } else {
    //                 showMessage({
    //                     status: true,
    //                     message: t('NO_DEVICE_FOUND'), //TODO: correct message
    //                 });
    //             }
    //         } catch (ex) {
    //             console.log("onSubmitSwapDevice ex:", ex);
    //             showMessage({
    //                 status: true,
    //                 message: t('EXCEPTION_PROCESS'),
    //             });
    //         }
    //         setShowProcessing(false);
    //     } else {
    //         await onUpdateActivity(note);
    //         props.onReloadRemoveList();
    //     }
    // }

    useEffect(() => {
        if (activity && activity.contact && activity.contact.id) {
            onLoadContactAttachments(activity.contact.id);
            onLoadNoteActivity()
            setAllNote([])
        }
    }, [activity]);
   

    useEffect(() => {
        if (isLoadedAttachments) {
            updateActivity(contactAttachments);
        }
    }, [isLoadedAttachments]);

    const updateActivity = (attachments) => {
        let custom_fields = activity?.custom_fields;
        let fileCustomFields = getCustomFieldByKey(custom_fields, 'attachments_file_id');
        
        if (fileCustomFields) {
            let contactFiles = attachments.filter(attm => {
                return fileCustomFields.includes(attm.file.id);
            })
            
            if (contactFiles && contactFiles.length > 0) {
                setActivity(prevActivity => ({
                    ...prevActivity,
                    files: contactFiles
                }));
            }
        }
    }

    const onLoadContactAttachments = async (contactId) => {
        let attachments = [];
        try {
            const result = await crmservices.attachments.getListAttachments({ contact_id: contactId });
            
            if (result.code == 'OK') {
                attachments = result.data.content ? result.data.content : [];
                setContactAttachments(attachments);
                setIsLoadedAttachments(true);
            }
        } catch (ex) {

        }
    }

    const get_url_extension = (url) => {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }

    const onShowFile = async (file) => {
        setShowProcessing(true);
        try {
            let extention = get_url_extension(file.name);
            console.log("extention:", extention);
            const accessToken = getData('access_token')
            var url = connection.crmConfig.crmServer + '/backoffice/v1/files/' + file.id;
            let result = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    method: 'GET',
                }
            });
            let resultBlob = await result.blob();
            window.open(window.URL.createObjectURL(resultBlob))
        } catch (error) {
            console.log("load files service request exception:", error);
        }
        setShowProcessing(false);
    }

    const onAddEnableBox = async (act) => {
        let actionToShow = 'additionalBox';        
        if (activity && activity.contact) {
            setOrderDetail(activity.contact);
            setShowDetail((prevState) => ({
                ...prevState,
                [actionToShow]: true,
                }));
            checkActiveTab(activity);
            setShowProcessing(false);
        }
        setClickAddDeviceBtn(true);
    }

    const onLoadActivityTypes = async () => {
        let _types = [];
        try {
            let page = 1;
            let size = 50;
            let result = await crmservices.activities.getActivitiesType({
                page: page,
                size: size,
                state: 'ACTIVE',
                include_total: true,
            });
            if(result.code == 'OK') {
                _types = result.data && result.data.content ? result.data.content : [];
                let paging = result.data && result.data.paging ? result.data.paging : {
                    size: size,
                    page: page,
                    total: 0,
                    has_more: false,
                };
                while(paging.has_more) {
                    result = await crmservices.activities.getActivitiesType({
                        page: page+1,
                        size: size,
                        state: 'ACTIVE',
                        include_total: true,
                    });
                    _types = _types.concat(result.data && result.data.content ? result.data.content : []);
                }
            }
            console.log("AAAA onLoadActivityTypes _types: ", _types);
        } catch (error) {
            console.log("AAAA onLoadActivityTypes error: ", error)
        }
        setTypes(_types)
    }

    const onLoadActivityStatuses = async () => {
        let _statuses = [];
        try {
            let result = await crmservices.config.getCustomFields({ entity: 'ACTIVITIES' });
            console.log("AAAA onLoadActivityStatuses result: ", result);
            if(result.code == 'OK') {
                if(result.data && result.data.content && result.data.content.length > 0) {
                    let existStatus = result.data.content.filter(x => x.key == 'status');
                    if(existStatus && existStatus.length > 0) {
                        _statuses = existStatus[0].options;
                    }
                }
            }
        } catch (error) {
            console.log("AAAA onLoadActivityStatuses error: ", error)
        }
        setStatuses(_statuses);
    }

    const onLoadCityCustomFields = async () => {
        let _cities = [];
        try {
            let result = await crmservices.config.getCustomFields({ entity: 'CONTACTS' });
            console.log("AAAA onLoadCityCustomFields result: ", result);
            if(result.code == 'OK') {
                if(result.data && result.data.content && result.data.content.length > 0) {
                    let existCity = result.data.content.filter(x => x.key == 'city');
                    if(existCity && existCity.length > 0) {
                        _cities = existCity[0].options;
                    }
                }
            }
        } catch (error) {
            console.log("AAAA onLoadCityCustomFields error: ", error)
        }
        setCities(_cities);
    }

    const onSearch = (values) => {
        console.log("AAAA onSearch values: ", values);
        setPageTotal(0);
        setIsSearching(true);
        let _newData = [];
        try {
            let query = 'x => ';
            if(typesSelected && typesSelected.length > 0) {
                // _newData = activities.filter(x => x.type && x.type.id == values.type);
                query += `x.type && [${typesSelected.map(type => `"${type}"`).join(', ')}].includes(x.type.id)`;
            }
            if(values.status) {
                if(query.length > 5) query += `&& x.custom_fields && x.custom_fields.some(c => c.key == 'status' && c.value.toLowerCase() == "${values.status.toLowerCase()}")`;
                else query += `x.custom_fields && x.custom_fields.some(c => c.key == 'status' && c.value.toLowerCase() == "${values.status.toLowerCase()}")`
            }
            if(values.scheduled_date_from) {
                let from = Math.floor(new Date(values.scheduled_date_from + ' 00:00:00').getTime() / 1000);
                console.log("AAAA onSearch from: ", from)
                if(query.length > 5) query += `&& x.date >= ${from}`;
                else query += `x.date >= ${from}`
            }
            if(values.scheduled_date_to) {
                let to = Math.floor(new Date(values.scheduled_date_to + ' 23:59:59').getTime() / 1000);
                console.log("AAAA onSearch to: ", to)
                if(query.length > 5) query += `&& x.date <= ${to}`;
                else query += `x.date <= ${to}`;
            }
            if(citySelected && citySelected.text) {
                if(query.length > 5) query += `&& x.address && x.address.town_city && x.address.town_city.toLowerCase().includes("${citySelected.text.toLowerCase()}")`
                else query += `x.address && x.address.town_city && x.address.town_city.toLowerCase().includes("${citySelected.text.toLowerCase()}")`
            }
            console.log("AAAA query: ", query)
            if(query == 'x => ') setIsSearching(false)
            else if(query) _newData = activities.filter(eval(`(${query})`));
        } catch (error) {
            console.log("AAAA onSearch error: ", error)
        }
        setDataSearch(_newData);
    }

    const onRemoveDevice = async (form) => {
        let contactId = activity.contact ? activity.contact.id : null;
        if (removedDevice) {
            setShowProcessing(true);
            try {
                const result = await crmservices.subscriptions.getDevice({
                    contact_id: contactId,
                    serial_number: removedDevice,
                    in_warehouse: false,
                })
                if (result.code == 'OK' && result.data.content && result.data.content.length > 0) {
                    let device = result.data.content[0];
                    if (device.subscriptions && device.subscriptions.length > 0) {
                        if (device.enabled_services) {
                            let check = device.enabled_services.find((service) => (service.life_cycle_state === "DRAFT" || service.life_cycle_state === "EFFECTIVE"));
                            if (check) {
                                showMessage({ status: true, message: t('REMOVE_DEVICE_EXCEPTION') });
                                return;
                            }
                        }
                        let subscriptionId = device.subscriptions[0].id;
                        const result2 = await crmservices.subscriptions.updateSubscriptionDevice({ action: "REMOVE" }, subscriptionId, device.id);
                        props.setShowProcessing(false);
                        if (result2.code == 'OK') {
                            form.change('removedSerial', '');
                            showMessage({ status: true, message: t('REMOVE_SUCCESS') });
                            await onUpdateActivityDeviceCustomFields(null, removedDevice);

                            //update removed device to assign back contractor
                            let myUserId = httpBackOfficeUtil.getSession().sub;
                            let custom_fields = device.custom_fields ? device.custom_fields : [];
                            custom_fields = createCustomFieldObj(custom_fields, "contractor", myUserId);
                            if (device.id){
                                crmservices.subscriptions.updateDevice({ custom_fields: custom_fields }, device.id);
                            }
                        }
                        else if (result2.code == 'CANNOTEXECUTESUBSCRIPTIONACTIONEXCEPTION') {
                            showMessage({ status: true, message: t('REMOVE_DEVICE_EXCEPTION') });
                        }
                        else {
                            showMessage({
                                status: true,
                                message: t('UNKNOWN'), //TODO: correct message
                            });
                        }
                    }
                } else {
                    showMessage({
                        status: true,
                        message: t('NO_DEVICE_FOUND'), //TODO: correct message
                    });
                }
            } catch (ex) {
                console.log("onSubmitRemoveDevice ex:", ex);
                showMessage({
                    status: true,
                    message: t('EXCEPTION_PROCESS'),
                });
            }
            setShowProcessing(false);
        } else {
            setValidate(true)
        }
    }
    
    const onSwapDevice = async (form) => {
       
        let contactId = activity.contact ? activity.contact.id : null;
        if (removedDevice && addedDevice) {
            setShowProcessing(true);
            try {
                const result = await crmservices.subscriptions.getDevice({
                    contact_id: contactId,
                    serial_number: removedDevice,
                    in_warehouse: false,
                })
                if (result.code == 'OK' && result.data.content && result.data.content.length > 0) {
                    let deviceRemoved = result.data.content[0];
                    let deviceAdded = await getSubscriptionDevice(addedDevice);
                    if (deviceRemoved.subscriptions && deviceRemoved.subscriptions.length > 0 && deviceAdded) {
                        let subscriptionId = deviceRemoved.subscriptions[0].id;
                        const result2 = await crmservices.subscriptions.updateSubscriptionDevice({ action: "REPLACE", replaced_by_device_id: deviceAdded.id }, subscriptionId, deviceRemoved.id);
                        setShowProcessing(false);
                        if (result2.code == 'OK') {
                            form.change('removedSerial', '');
                            form.change('addedSerial', '');
                            showMessage({ status: true, message: t('SWAP_SUCCESS') });
                            await onUpdateActivityDeviceCustomFields(addedDevice, removedDevice);

                            //update removed device to assign back contractor
                            let myUserId = httpBackOfficeUtil.getSession().sub;
                            let custom_fields = deviceRemoved.custom_fields ? deviceRemoved.custom_fields : [];
                            custom_fields = createCustomFieldObj(custom_fields, "contractor", myUserId);
                            if (deviceRemoved.id){
                                crmservices.subscriptions.updateDevice({ custom_fields: custom_fields }, deviceRemoved.id);
                            }
                        } else if (result2.code == 'CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION') {
                            showMessage({
                                status: true,
                                message: t('SWAP_DEVICE_CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION'),
                            });
                        }
                        else {
                            showMessage({
                                status: true,
                                message: t('UNKNOWN'), //TODO: correct message
                            });
                        }
                    }
                } else {
                    showMessage({
                        status: true,
                        message: t('NO_DEVICE_FOUND'), //TODO: correct message
                    });
                }
            } catch (ex) {
                console.log("onSubmitRemoveDevice ex:", ex);
                showMessage({
                    status: true,
                    message: t('EXCEPTION_PROCESS'),
                });
            }
            setShowProcessing(false);
        } else {
            if (!removedDevice) {
                setValidate((prev) => ({ ...prev, remove: true }))
            }
            if (!addedDevice) {
                setValidate((prev) => ({ ...prev, add: true }))
            }
        }
    }

    const onUpdateActivityDeviceCustomFields = async (addedDevice, removedDevice) => {
        const getActivityRsl = await crmservices.activities.getActivity(activity.id);
        console.log('onUpdateActivityDeviceCustomFields, getActivityRsl = ', getActivityRsl);
        if (getActivityRsl.code == 'OK') {
            let _activity = getActivityRsl.data;
            let custom_fields = _activity.custom_fields ? _activity.custom_fields : [];

            if(removedDevice){
                let _deviceRemovedExist = getCustomFieldByKey(custom_fields, "device_removed");
                if(_deviceRemovedExist){
                    removedDevice = _deviceRemovedExist + ',' + removedDevice;                    
                }

                custom_fields = createCustomFieldObj(custom_fields, "device_removed", removedDevice);
            }
            
            if(addedDevice){
                let _deviceAddedExist = getCustomFieldByKey(custom_fields, "device_added");
                if(_deviceAddedExist){
                    addedDevice = _deviceAddedExist + ',' + addedDevice;                    
                }

                custom_fields = createCustomFieldObj(custom_fields, "device_added", addedDevice);
            }

            if(addedDevice || removedDevice){
                console.log('custom fields tobe updated= ', custom_fields);        
                try {
                    const result = await crmservices.activities.updateActivity({ activity_id: _activity.id
                        , custom_fields: custom_fields});

                    console.log('onUpdateActivityDeviceCustomFields = ', result);        
                    if (result.code == 'OK') {
                        // onLoadActivities(paging.page, paging.size);
                        // showMessage({ status: true, message: t('UPDATE_ACTIVITY_SUCCESS') })
                    } else {
                        showMessage({ status: true, message: (result.data && result.data.message) ? result.data.message : t('UPDATE_ACTIVITY_FAIL') })
                    }
                        
                } catch (ex) {
                    console.log("onUpdateActivityDeviceCustomFields ex:", ex);
                    showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
                }   
            }
        }
    }

    console.log("showDetail:", showDetail)
    console.log("orderDetail:", orderDetail)
    console.log("activity:", activity)

    return (
        <>
            <TotalActivitiesView
                activities={activities}
                paging={paging}
                showLoading={showLoading}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                onShowDetail={onShowDetail}
                showExecutionProcess={showExecutionProcess}
                actionState={actionState}
                isSelfScheduleingUser={isSelfScheduleingUser}   
                types={types}
                isSearching={isSearching}
                dataSearch={dataSearch}
                typesSelected={typesSelected}
                statuses={statuses}
                citySelected={citySelected}
                cities={cities}
                setIsSearching={setIsSearching}
                onSearch={onSearch}
                setTypesSelected={setTypesSelected}  
                setCitySelected={setCitySelected}    
                pageTotal={pageTotal}
                setPageTotal ={setPageTotal}
            />
            {showDetail.uninstallation && <RemoveDeviceDetailView
                isOpen={showDetail.uninstallation}
                onClose={() => onCloseDetail('uninstallation')}
                onSubmit={completeActivity}
                activity={activity}
                files={files}
                setShowUploadFile={setShowUploadFile}
                onDeleteFile={onDeleteFile}
                onShowFile={onShowFile}
                onSave={onUpdateActivity}
                isSelfScheduleingUser={isSelfScheduleingUser}   
                setChangeRemoveDevice={setChangeRemoveDevice}
                onRemoveDevice={onRemoveDevice}
                validate={validate}
                setValidate={setValidate}
                setAllNote={setAllNote}
                allNote={allNote}     
                dataNoteActivity={dataNoteActivity}   
                pagingNote={pagingNote}   
                loadMoreNote={loadMoreNote}
                onLoadMoreNoteActivity={onLoadMoreNoteActivity}
            />}
            {showDetail.installation && <InstallationController
                orderDetail={orderDetail}
                activity={activity}
                isOpen={showDetail.installation}
                setShowProcessing={setShowProcessing}
                showMessage={showMessage}
                onClose={() => onCloseDetail('installation')}
                onReloadInstallationList={onLoadActivities}
                onDeleteFile={onDeleteFile}
                isSelfScheduleingUser={isSelfScheduleingUser}         
            />
            }
            {showDetail.swapping && <SwapDeviceDetailView
                isOpen={showDetail.swapping}
                onClose={() => onCloseDetail('swapping')}
                onSubmit={completeActivity}
                activity={activity}
                files={files}
                setShowUploadFile={setShowUploadFile}
                onDeleteFile={onDeleteFile}
                onShowFile={onShowFile}
                onSave={onUpdateActivity}
                isSelfScheduleingUser={isSelfScheduleingUser}    
                setChangeRemoveDevice={setChangeRemoveDevice}
                setChangeAddDevice={setChangeAddDevice}
                onRemoveDevice={onSwapDevice}
                validate={validate}
                setValidate={setValidate}
                setAllNote={setAllNote}
                allNote={allNote}     
                dataNoteActivity={dataNoteActivity}
                pagingNote={pagingNote}   
                loadMoreNote={loadMoreNote}
                onLoadMoreNoteActivity={onLoadMoreNoteActivity}
            />}
            {showDetail.serviceVisit && <ServiceVisitDetailView
                isOpen={showDetail.serviceVisit}
                onClose={() => onCloseDetail('serviceVisit')}
                onSave={onUpdateActivity}
                activity={activity}
                files={files}
                setShowUploadFile={setShowUploadFile}
                onDeleteFile={onDeleteFile}
                onShowFile={onShowFile}
                isSelfScheduleingUser={isSelfScheduleingUser}      
                setAllNote={setAllNote}
                allNote={allNote}     
                dataNoteActivity={dataNoteActivity}   
                pagingNote={pagingNote}   
                loadMoreNote={loadMoreNote}
                onLoadMoreNoteActivity={onLoadMoreNoteActivity}
            />}
            {showDetail.reinstallation && <ReinstallationDetailView
                isOpen={showDetail.reinstallation}
                onClose={() => setShowDetail(false)}
                onSave={onUpdateActivity}
                activity={activity}
                files={files}
                setShowUploadFile={setShowUploadFile}
                onDeleteFile={onDeleteFile}
                onShowFile={onShowFile}
                isSelfScheduleingUser={isSelfScheduleingUser}
                setAllNote={setAllNote}
                allNote={allNote}     
                dataNoteActivity={dataNoteActivity}    
                pagingNote={pagingNote}   
                loadMoreNote={loadMoreNote}
                onLoadMoreNoteActivity={onLoadMoreNoteActivity}        
            />}
            {showDetail.other && <GeneralActivityDetailView
                isOpen={showDetail.other}
                onClose={() => setShowDetail(false)}
                onSave={onUpdateActivity}
                activity={activity}
                files={files}
                setShowUploadFile={setShowUploadFile}
                onDeleteFile={onDeleteFile}
                onShowFile={onShowFile}
                isSelfScheduleingUser={isSelfScheduleingUser}  
                setAllNote={setAllNote}
                allNote={allNote}     
                dataNoteActivity={dataNoteActivity}    
                pagingNote={pagingNote}   
                loadMoreNote={loadMoreNote}
                onLoadMoreNoteActivity={onLoadMoreNoteActivity}     
            />}
            {showDetail.additionalBox && <AdditionalBoxDetailView
                isOpen={showDetail.additionalBox}
                onClose={() => setShowDetail(false)}
                onSave={onUpdateActivity}
                activity={activity}
                files={files}
                setShowUploadFile={setShowUploadFile}
                onDeleteFile={onDeleteFile}
                onShowFile={onShowFile}
                additionalBox={true}
                onAddEnableBox={onAddEnableBox}    
                isSelfScheduleingUser={isSelfScheduleingUser} 
                setAllNote={setAllNote}
                allNote={allNote}     
                dataNoteActivity={dataNoteActivity}        
                pagingNote={pagingNote}   
                loadMoreNote={loadMoreNote}
                onLoadMoreNoteActivity={onLoadMoreNoteActivity}     
            />}
            {isClickAddDeviceBtn && <AdditionalBoxController
                isOpen={true}
                activity={activity}
                orderDetail={orderDetail}
                activeStepAddDevice={activeStepAddDevice}
                onClose={() => setClickAddDeviceBtn(false)}
                onLoadActivities={onLoadActivities}
                onCloseAll={() => setShowDetail(false)}
                isSelfScheduleingUser={isSelfScheduleingUser}         
            />}

            {/* {showDetail.additionalBox && (
                <AdditionalBoxController
                isOpen={showDetail.additionalBox}
                activity={activity}
                orderDetail={orderDetail}
                activeStepAddDevice={activeStepAddDevice}
                onClose={() => onCloseDetail("additionalBox")}
                />
            )} */}
            {showUploadFile && <ConfirmComponent isOpen={showUploadFile} enableCloseButton={true}
                title={'Upload File'}
                otherMessage={<UploadFile onUploadFile={uploadFiles} isMultipleFile={true} />}
                onClose={() => setShowUploadFile(false)}
                onAction={() => onSaveFilesState()}
            />}
        </>
    )
}